__turbopack_context__.v({
  "extraLarge": "Spinner-module__ESmPEW__extraLarge",
  "large": "Spinner-module__ESmPEW__large",
  "loaderContainer": "Spinner-module__ESmPEW__loaderContainer",
  "loadingOverlay": "Spinner-module__ESmPEW__loadingOverlay",
  "loadingSpinner": "Spinner-module__ESmPEW__loadingSpinner",
  "loadingText": "Spinner-module__ESmPEW__loadingText",
  "medium": "Spinner-module__ESmPEW__medium",
  "small": "Spinner-module__ESmPEW__small",
  "spin": "Spinner-module__ESmPEW__spin",
});
